import {registerTemplateGraphNode} from "#template/template-node/register"
import {curveGeometryAttributeSetLike, curveGeometryAttributeSetLikeMarker} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import type {CurveGeometryAttributeSetLikeNode} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import {curveGeometryAttributeLike} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {CurveGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {SplitOperatorParameters} from "#template/nodes/geometry-graph/attribute-set/split-operator/geometry-split-operator-node"
import {
    GeometrySplitOperatorNode,
    splitOperatorParametersSchema,
} from "#template/nodes/geometry-graph/attribute-set/split-operator/geometry-split-operator-node"
import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

export type CurveGeometrySplitOperatorParameters = SplitOperatorParameters<CurveGeometryAttributeLikeNode, CurveGeometryAttributeSetLikeNode>

const definition: TemplateNodeDefinition<CurveGeometrySplitOperatorParameters> = {
    nodeClass: "CurveGeometrySplitOperator",
    validation: {
        parameters: splitOperatorParametersSchema(curveGeometryAttributeLike, curveGeometryAttributeSetLike),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class CurveGeometrySplitOperator
    extends GeometrySplitOperatorNode<1, CurveGeometryAttributeLikeNode, CurveGeometryAttributeSetLikeNode>
    implements CurveGeometryAttributeSetLikeNode
{
    get [curveGeometryAttributeSetLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
